import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Logo from '../../js/Components/Logo';
import '../../css/Header.css';
import IsLoggedIn from '../../js/Components/IsLoggedIn';
import Cookies from 'js-cookie';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faCalendar, faChevronLeft, faChevronRight, faCog, faHouse, faRightFromBracket } from '@fortawesome/free-solid-svg-icons';

interface HeaderProps {
  variant: 'container' | 'admin';
  isAdminSidebarCollapsed?: boolean;
  onToggleAdminSidebar?: () => void;
}

const Header: React.FC<HeaderProps> = ({ variant, isAdminSidebarCollapsed = false, onToggleAdminSidebar }) => {
  const [isNavExpanded, setIsNavExpanded] = useState<boolean>(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => {
    Cookies.remove('userLoggedIn');
    setIsNavExpanded(false);
    navigate('/');
  };

  const closePublicMenu = () => setIsNavExpanded(false);

  return (
    <header className={`header-${variant}`}>
      {variant === 'container' ? (
        <div>
          <div className="content-wrap">
            <div className="header-top">
              <div className="header-left">
                <strong>Previa Cita </strong><span className="telefono_cita">33 34 75 81 91</span>
                <div className="direccion_cita">Teodomiro Manzano 4365, Guadalajara, Jal.</div>
              </div>
              <div className="header-center">
                <Logo />
              </div>
              <div className="header-right">
                <div>
                  <div className="horario_label">Horario:</div>
                  <div className="horario_consulta">Lun - Sab: <strong>10am - 7pm</strong> Dom: Cerrado</div>
                </div>
              </div>
            </div>
          </div>

          <div className="hr-top clearfix hr-shadow public-nav-shell">
            <div className="content-wrap public-nav-wrap">
              <button
                type="button"
                className="menu-toggle"
                aria-label={isNavExpanded ? 'Cerrar menú' : 'Abrir menú'}
                aria-expanded={isNavExpanded}
                onClick={() => setIsNavExpanded(!isNavExpanded)}
              >
                <FontAwesomeIcon icon={faBars} />
                <span>Menú</span>
              </button>

              <nav className="Navbar_container" aria-label="Navegación principal">
                <ul className={`Navbar_list ${isNavExpanded ? 'active' : ''}`}>
                  <li className={`Navbar_list_li ${location.pathname === '/' ? 'Navbar_current' : ''}`}>
                    <Link to="/" onClick={closePublicMenu}><span>Portada</span></Link>
                  </li>
                  <li className={`Navbar_list_li ${location.pathname === '/About' ? 'Navbar_current' : ''}`}>
                    <Link to="/About" onClick={closePublicMenu}><span>Acerca de</span></Link>
                  </li>
                  <li className={`Navbar_list_li ${location.pathname === '/Gallery' ? 'Navbar_current' : ''}`}>
                    <Link to="/Gallery" onClick={closePublicMenu}><span>Galería</span></Link>
                  </li>
                  <li className={`Navbar_list_li ${location.pathname === '/Contact' ? 'Navbar_current' : ''}`}>
                    <Link to="/Contact" onClick={closePublicMenu}><span>Contacto</span></Link>
                  </li>
                  <li className={`Navbar_list_li ${location.pathname === '/Account' ? 'Navbar_current' : ''}`}>
                    <Link to="/Account" onClick={closePublicMenu}><span>Tu Cuenta</span></Link>
                  </li>
                  <IsLoggedIn cookieName="userLoggedIn">
                    {{
                      exist: (
                        <li className={`Navbar_list_li ${location.pathname.startsWith('/AdminPanel') ? 'Navbar_current' : ''}`}>
                          <Link to="/AdminPanel" onClick={closePublicMenu}><span>Admin Panel</span></Link>
                        </li>
                      )
                    }}
                  </IsLoggedIn>
                  <IsLoggedIn cookieName="userLoggedIn">
                    {{
                      exist: (
                        <li className="Navbar_list_li">
                          <button type="button" className="nav-link-button" onClick={handleLogout}>Cerrar Sesión</button>
                        </li>
                      )
                    }}
                  </IsLoggedIn>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      ) : (
        <div className="admin-sidebar-inner">
          <Link to="/" className="sidebar-brand d-flex align-items-center justify-content-center" title="Volver al sitio">
            <Logo />
          </Link>

          <div className="sidebar-heading">Panel</div>

          <nav aria-label="Navegación de administrador">
            <ul className="navbar-nav bg-gradient-primary sidebar sidebar-light accordion" id="accordionSidebar">
              <li className={`nav-item ${location.pathname === '/AdminPanel' ? 'active' : ''}`}>
                <Link to="/AdminPanel" className="nav-link">
                  <FontAwesomeIcon icon={faHouse} />
                  <span>Inicio</span>
                </Link>
              </li>

              <li className={`nav-item ${location.pathname === '/AdminPanel/Agenda' ? 'active' : ''}`}>
                <Link to="/AdminPanel/Agenda" className="nav-link">
                  <FontAwesomeIcon icon={faCalendar} />
                  <span>Agenda</span>
                </Link>
              </li>

              <li className={`nav-item ${location.pathname === '/AdminPanel/Pacientes' ? 'active' : ''}`}>
                <Link to="/AdminPanel/Pacientes" className="nav-link">
                  <FontAwesomeIcon icon={faCog} />
                  <span>Pacientes</span>
                </Link>
              </li>
            </ul>
          </nav>

          <button
            type="button"
            className="sidebar-toggle"
            aria-label={isAdminSidebarCollapsed ? 'Expandir menú lateral' : 'Colapsar menú lateral'}
            onClick={onToggleAdminSidebar}
          >
            <FontAwesomeIcon icon={isAdminSidebarCollapsed ? faChevronRight : faChevronLeft} />
          </button>

          <button type="button" className="admin-logout-button" onClick={handleLogout}>
            <FontAwesomeIcon icon={faRightFromBracket} />
            <span>Cerrar sesión</span>
          </button>
        </div>
      )}
    </header>
  );
};

export default Header;
